import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ErrorDialogComponent } from './error-dialog.component';

/**
 * Open error dialog dialog
 *
 * @param dialog mat dialog instance
 * @returns promise MatDialog ref
 */
export const openErrorDialog = (
  dialog: MatDialog,
  codeErr: string,
  descriptionErr: string,
  source?: string,
  closeOnly: boolean = false
): Promise<MatDialogRef<ErrorDialogComponent>> => {
  return dialog
    .open(ErrorDialogComponent, {
      maxWidth: '100vw',
      maxHeight: '100vh',
      minWidth: '100vw',
      panelClass: 'dialog-error-panel',
      data: { code: codeErr, description: descriptionErr, source, closeOnly },
      ariaLabel: descriptionErr,
    })
    .afterClosed()
    .toPromise();
};